import axios from "axios";
import { toast } from "react-toastify";
import {
  BaseURL,
  apiHeader,
  formRegEx,
  formRegExReplacer,
} from "../config/apiUrl";
import { Delete, Patch } from "../Axios/AxiosFunctions";
import moment from "moment";
import heic2any from "heic2any";

export const UploadVideosToAwsBySignedUrl = async (
  urlsArray,
  videos,
  setVideoProgress
) => {
  const promises = urlsArray.map((url, index) => {
    return axios.put(url, videos[index], {
      headers: {
        "Content-Type": videos[index]?.type,
        "ngrok-skip-browser-warning": "69420",
      },
      onUploadProgress: (data) => {
        setVideoProgress(
          Math.round(((100 * data.loaded) / data.total) * (index + 1))
        );
      },
    });
  });
  const results = await Promise.allSettled(promises);
  return results;
};
export const validateAddFields = (propertyFields) => {
  for (let i = 0; i < propertyFields.length; i++) {
    const element = propertyFields[i];
    if (element?.value == "" || element?.value == null) {
      toast.error(`Please fill value for ${element?.label} field!`);
      return false;
    }
  }
  return true;
};
const imageTypes = ["png", "jpeg", "jpg", "jfif"];
const videoTypes = ["mp4"];

export const handleDeleteMeadia = async (
  name,
  deletedSlug,
  access_token,
  deletedFiles
) => {
  for (let i = 0; i < deletedFiles.length; i++) {
    const params = {
      key: deletedFiles[i],
      mediaType: imageTypes?.includes(
        deletedFiles[i].split(".")?.pop()?.toLowerCase()
      )
        ? "image"
        : videoTypes?.includes(deletedFiles[i].split(".")?.pop()?.toLowerCase())
        ? "video"
        : "",
    };
    const apiUrl = BaseURL(`${name}/media/delete/${deletedSlug}`);
    const response = await Patch(apiUrl, params, apiHeader(access_token));
    if (response == undefined) {
      return false;
    }
  }
  return true;
};
export const validateProductFields = (productFields) => {
  for (let i = 0; i < productFields.length; i++) {
    const element = productFields[i];
    for (let key in element) {
      if (!element[key]) {
        toast.error(
          `Please fill ${key
            .replace(formRegEx, formRegExReplacer)
            .toLowerCase()} field for product ${i + 1}!`
        );
        return false;
      }
    }
  }
  return true;
};
export const validateAreaFields = (areaFields) => {
  for (let i = 0; i < areaFields.length; i++) {
    const element = areaFields[i];
    for (let key in element) {
      if (key == "areaTitle" && !element[key]) {
        toast.error(
          `Please fill ${key
            .replace(formRegEx, formRegExReplacer)
            .toLowerCase()} field for area ${i + 1}!`
        );
        return false;
      }
      if (key == "productData") {
        if (!validateAreaProducts(element[key], i)) return false;
      }
    }
  }
  return true;
};
const validateAreaProducts = (products, areaIndex) => {
  for (let i = 0; i < products.length; i++) {
    const element = products[i];
    for (let key in element) {
      if (!element[key]) {
        toast.error(
          `Please fill ${key
            .replace(formRegEx, formRegExReplacer)
            .toLowerCase()} field for product ${i + 1} in area ${
            areaIndex + 1
          }!`
        );
        return false;
      }
      if (Number(element?.fullQuantity) < Number(element?.threshold)) {
        toast.error(
          `Threshold value should be less than full quantity for area ${i + 1}!`
        );
        return false;
      }
      // if (Number(element?.currentQuantity) > Number(element?.fullQuantity)) {
      //   toast.error(
      //     `Current quantity should be less than full quantity for area ${
      //       i + 1
      //     }!`
      //   );
      //   return false;
      // }
    }
  }
  return true;
};
export const getTimeStamp = (date) => {
  const now = moment();
  const givenDate = moment(date);
  const duration = moment.duration(now.diff(givenDate));

  const years = duration.years();
  const months = duration.months();
  const weeks = duration.weeks();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes();

  if (years > 0) return `${years} ${years == 1 ? "Year" : "Years"} Ago`;
  if (months > 0) return `${months} ${months == 1 ? "Month" : "Months"} Ago`;
  if (weeks > 0) return `${weeks} ${weeks == 1 ? "Week" : "Weeks"} Ago`;
  if (days > 0) return `${days} ${days == 1 ? "Day" : "Days"} Ago`;
  if (hours > 0) return `${hours} ${hours == 1 ? "Hour" : "Hours"} Ago`;
  if (minutes > 0) return `${minutes} Minutes Ago`;

  return "Just now";
};
export const getFieldColor = (status) => {
  switch (status) {
    case "completed":
      return "#017EFA";
    case "assigned":
      return "#30DA88";
    case "unassigned":
      return "#51CBFF";
    case "help":
      return "#FB6360";
    case "reschedule":
      return "#192b6b";
    default:
      return "#017EFA";
  }
};
export const statusBackgroundColor = (status) => {
  switch (status) {
    case "completed":
      return "#E6F2FE";
    case "assigned":
      return "#64E3A626";
    case "unassigned":
      return "#51CBFF26";
    case "help":
      return "#F6615E26";
    case "reschedule":
      return "#F6615E26";
    default:
      return "#017EFA";
  }
};
export const getDoughnutData = (data) => {
  const labels = data?.map((ele) =>
    ele?._id === "help" ? "Review" : firstLetterCapital(ele?._id)
  );
  const fieldsData = data?.map((ele) => ele?.count);
  const doughnutData = {
    labels,
    datasets: [
      {
        label: "%",
        data: fieldsData,
        backgroundColor: data?.map((ele) => getFieldColor(ele?._id)),
        borderColor: data?.map((ele) => getFieldColor(ele?._id)),
        borderWidth: 1,
      },
    ],
  };
  return doughnutData;
};
export const getStatusPercentage = (data) => {
  const total = data?.reduce((acc, ele) => acc + ele?.count, 0);
  const statusPercentage = data?.map((ele) => ({
    ...ele,
    percentage: Math.round((ele?.count / total) * 100),
  }));
  return statusPercentage;
};
export const getDataForInventory = (inventories) => {
  let formattedData = [];
  for (let i = 0; i < inventories?.length; i++) {
    let obj = {};
    const inventoryElement = inventories?.[i];
    obj = {
      _id: inventoryElement?._id,
      property: inventoryElement?.property,
    };
    for (let j = 0; j < inventoryElement?.areaData?.length; j++) {
      const element = inventoryElement?.areaData?.[j];
      element?.productData?.forEach((ele) => {
        obj = {
          ...obj,
          itemName: ele?.itemName,
          currentQuantity: ele?.currentQuantity,
          threshold: ele?.threshold,
          createdAt: inventoryElement?.createdAt,
          inventoryLevel: inventoryElement?.inventoryLevel,
        };
      });
    }
    formattedData?.push(obj);
  }
  return formattedData;
};
export const getPercenetageFromValue = (value, totalValue) => {
  if (!value || !totalValue) return 0;
  const percentage = (value / totalValue) * 100;
  return percentage > 100 ? 100 : percentage?.toFixed(2);
};
export const separateMediaFiles = (files) => {
  const images = [];
  const videos = [];
  files.forEach((ele) => {
    if (["image", "application"]?.includes(ele?.type?.split("/")[0])) {
      images.push(ele);
    } else if (ele?.type?.split("/")[0] == "video") {
      videos.push(ele);
    }
  });
  return { images, videos };
};
export const dateFormatter = (date, format = "MM/DD/YYYY") => {
  if (date?.$d) {
    return moment(date?.$d).format(format);
  } else if (date) {
    return moment(date).format(format);
  } else {
    return null;
  }
};
export const priorityColor = (priority) => {
  switch (priority) {
    case "highest":
      return "#FF4136";
    case "mid-level":
      return "#FF851B";
    case "lowest":
      return "#2ECC40";
    case "none":
      return "#AAAAAA";
    default:
      return "#AAAAAA";
  }
};
export const getVideoUrl = (video) => {
  return video.split("X-Amz-Algorithm")[0];
};
export const firstLetterCapital = (string) => {
  if (!string) return string;
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};
export function convertMinutesToTime(minutes, showMinutes = true) {
  const MINUTES_IN_HOUR = 60;
  const hours = Math.floor(minutes / MINUTES_IN_HOUR);
  const remainingMinutes = minutes % MINUTES_IN_HOUR;
  let timeString = "";

  if (hours > 0) {
    timeString += `${hours} hr${hours > 1 ? "s" : ""}`;
  }

  if (showMinutes && remainingMinutes > 0) {
    timeString += `${timeString ? " & " : ""}${remainingMinutes} min${
      remainingMinutes > 1 ? "s" : ""
    }`;
  }

  if (!timeString) {
    timeString = "0 mins";
  }

  return timeString;
}
export function millisecondsToMinutes(milliseconds) {
  return convertMinutesToTime(Math.floor(milliseconds / 60000));
}
export const mergeDateTime = (date, time) => {
  if (!time) {
    const formatedDate = moment(`${date}`).format("MM/DD/YYYY");
    const formatedTime = moment(`${date}`).format("hh:mm a");
    const mergedTime = moment(
      `${formatedDate} ${formatedTime}`,
      "MM/DD/YYYY hh:mm A"
    ).format();
    return mergedTime;
  } else if (!date) {
    const formatedDate = moment(`${time}`).format("MM/DD/YYYY");
    const formatedTime = moment(`${time}`).format("hh:mm a");
    const mergedTime = moment(
      `${formatedDate} ${formatedTime}`,
      "MM/DD/YYYY hh:mm A"
    ).format();
    return mergedTime;
  }
  const formatedDate = moment(`${date}`).format("MM/DD/YYYY");
  const formatedTime = moment(`${time}`).format("hh:mm a");
  const mergedTime = moment(
    `${formatedDate} ${formatedTime}`,
    "MM/DD/YYYY hh:mm A"
  ).format();
  return mergedTime;
};
export const validateStartEnd = (startTime, endTime) => {
  if (moment(endTime).diff(startTime) > 0) {
    return true;
  }
  return false;
};
export const validate_time_less_than_current = (startTime) => {
  if (moment().diff(startTime) > 0) {
    return true;
  }
  return false;
};
export const validate_time_greated_than_current = (endTime) => {
  if (moment().diff(endTime) > 0) {
    return true;
  }
  return false;
};
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
export async function convertImageFile(file) {
  if (file.type === "image/heic") {
    try {
      const convertedBlob = await heic2any({
        blob: file,
        toType: "image/jpeg",
      });
      return new File([convertedBlob], file.name.replace(/\.heic$/i, ".jpg"), {
        type: "image/jpeg",
        lastModified: Date.now(),
      });
    } catch (error) {
      throw error;
    }
  } else if (file.type === "image/webp") {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = URL.createObjectURL(file);
      await new Promise((resolve) => {
        img.onload = resolve;
      });
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          const convertedFile = new File(
            [blob],
            file.name.replace(/\.webp$/i, ".jpg"),
            {
              type: "image/jpeg",
              lastModified: Date.now(),
            }
          );
          resolve(convertedFile);
        }, "image/jpeg");
      });
    } catch (error) {
      throw error;
    }
  }
  return file;
}

export function getTimeDifference(starttime, endtime, format) {
  // Parse the times using moment
  let startMoment = moment(starttime);
  let endMoment = moment(endtime);

  // Calculate the difference in minutes
  let totalMinutes = endMoment.diff(startMoment, "minutes");
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;

  if (format === "hours") {
    return hours;
  }
  if (format === "minutes") {
    return minutes;
  }
}

export function convertMinutesToHoursMinutes(minutes, format) {
  let hours = Math.floor(minutes / 60); // Gets the whole hours
  let remainingMinutes = minutes % 60; // Gets the remainder minutes
  if (format === "hours") {
    return hours || 0;
  }
  if (format === "minutes") {
    return remainingMinutes || 0;
  }
}
export const dateValues = (date) => {
  switch (date) {
    case "Today":
      return 1;
    case "Yesterday":
      return 2;
    case "Earlier This Week":
      return 3;
    case "Last Week":
      return 4;
    case "Last Month":
      return 5;
    case "Earlier This Year":
      return 6;
    case "Older":
      return 7;
    default:
      break;
  }
};
export const getReceiptsWithDate = (receipts) => {
  const reducedReceipts = receipts.reduce((acc, ele) => {
    const currentDate = moment();
    const date = moment(ele?.assignment?.assignmentEndTime);

    if (date.isSame(currentDate, "day")) {
      acc["Today"] = [...(acc["Today"] || []), ele];
    } else if (date.isSame(currentDate, "month")) {
      acc["This Month"] = [...(acc["This Month"] || []), ele];
    } else if (date.isSame(currentDate.subtract(1, "month"), "month")) {
      acc["Last Month"] = [...(acc["Last Month"] || []), ele];
    } else if (date.isSame(currentDate, "year")) {
      acc["Earlier This Year"] = [...(acc["Earlier This Year"] || []), ele];
    } else {
      acc["Older"] = [...(acc["Older"] || []), ele];
    }
    return acc;
  }, {});
  const sortedReceipts = [
    "Today",
    "This Month",
    "Last Month",
    "Earlier This Year",
    "Older",
  ].reduce((acc, key) => {
    if (reducedReceipts[key]) {
      acc[key] = reducedReceipts[key];
    }
    return acc;
  }, {});

  return sortedReceipts;
};
export function downloadFileFromUrl(fileUrl, filename) {
  axios
    .get(fileUrl, {
      responseType: "blob",
      // ...options,
    })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}
export const validateCompletedAssignment = (assignments) => {
  const assignments_arr = [];
  for (let i = 0; i < assignments.length; i++) {
    let transformed_obj = {};
    const assignment = assignments[i];
    for (let key in assignment) {
      if (key === "assignmentDetail") continue;
      if (!assignment[key]) {
        toast.error(
          `${key
            .replace(formRegEx, formRegExReplacer)
            .toLowerCase()} cannot be empty for assignment ${i + 1}!`
        );
        return false;
      }
    }
    const combinedStartDate = mergeDateTime(
      assignment?.date?.$d || assignment?.date,
      assignment?.assignmentOriginalStartTime
    );
    const combinedEndDate = mergeDateTime(
      assignment?.date?.$d || assignment?.date,
      assignment?.assignmentEndTime
    );

    if (!validateStartEnd(combinedEndDate, moment().format())) {
      toast.error(
        `End Time must be less than Current Time for Assignment ${i + 1}!`
      );
      return false;
    }
    if (!validateStartEnd(combinedStartDate, combinedEndDate)) {
      toast.error(
        `End Time must be greater than Start Time for Assignment ${i + 1}!`
      );
      return false;
    }
    const { property, assignmentName, assignmentDetail, assignee } = assignment;
    transformed_obj = {
      property: property?._id,
      assignee: assignee?._id,
      assignmentName,
      assignmentDetail,
      assignmentOriginalStartTime: combinedStartDate,
      assignmentEndTime: combinedEndDate,
    };
    assignments_arr.push(transformed_obj);
  }
  return assignments_arr;
};
export const sortProperties = (data) => {
  const temp = [...data];
  return temp?.sort?.((a, b) => {
    return a?.propertyName.localeCompare(b?.propertyName);
  });
};
